import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Spin } from 'antd';
import SearchForm from './components/SearchForm'
import SearchResult from './components/SearchResult'
@inject('permissionManagementStore')
@observer
class PermissionManagement extends Component {
  state = {
  }
  componentDidMount() {
  }
  render() {
    const { permissionManagementStore,location } = this.props
    const { isFetching } = permissionManagementStore
    return (
      <Spin spinning={isFetching}>
        <div className="container">
          <SearchForm  location={location}/>
          <SearchResult />
        </div>
      </Spin>
    );
  }
}
export default PermissionManagement;
